




// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { 
//   createUserWithEmailAndPassword, 
//   signInWithEmailAndPassword,
//   signOut,
//   sendEmailVerification
// } from 'firebase/auth';
// import { 
//   doc, 
//   setDoc, 
//   getDoc, 
//   serverTimestamp 
// } from 'firebase/firestore';
// import { auth, db } from '../../firebase/firebaseConfig';
// import './Login.css';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [name, setName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [deliveryAddress, setDeliveryAddress] = useState('');
//   const [isRegistering, setIsRegistering] = useState(false);
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState('');
//   const [isAuthChecking, setIsAuthChecking] = useState(true); // Add loading state for auth check
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Get the redirect URL from the location state, default to '/profile'
//   const redirectTo = location.state?.from || '/profile'; // Change default to profile

//   // Check if user is already logged in
//   useEffect(() => {
//     const checkAuth = async () => {
//       setIsAuthChecking(true); // Start with auth checking
      
//       // Try to get cached auth data first for faster response
//       try {
//         const userData = localStorage.getItem('userData');
//         const authToken = localStorage.getItem('authToken');
        
//         if (userData && authToken) {
//           // If we have cached data, redirect immediately
//           navigate(redirectTo);
//           return; // Exit early since we're redirecting
//         }
//       } catch (err) {
//         console.error("Error checking localStorage:", err);
//       }
      
//       // Wait for auth to initialize
//       const unsubscribe = auth.onAuthStateChanged(async (user) => {
//         if (user) {
//           // User is already logged in, fetch user data from Firestore
//           try {
//             const userDoc = await getDoc(doc(db, 'users', user.uid));
//             if (userDoc.exists()) {
//               const userData = userDoc.data();
//               // Store user data in localStorage for app usage
//               localStorage.setItem('userData', JSON.stringify({
//                 uid: user.uid,
//                 email: user.email,
//                 name: userData.name,
//                 phone: userData.phone,
//                 deliveryAddress: userData.deliveryAddress
//               }));
              
//               // Store auth token
//               const token = await user.getIdToken();
//               localStorage.setItem('authToken', token);
              
//               // UNCOMMENTED: Redirect if they're already logged in
//               navigate(redirectTo);
//             }
//           } catch (err) {
//             console.error("Error fetching user data:", err);
//           }
//         }
        
//         setIsAuthChecking(false); // Auth check complete
//       });
      
//       // Clean up subscription
//       return () => unsubscribe();
//     };
    
//     checkAuth();
//   }, [navigate, redirectTo]);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     setLoading(true);

//     try {
//       // Sign in with Firebase Authentication
//       const userCredential = await signInWithEmailAndPassword(auth, email, password);
//       const user = userCredential.user;

//       // Get user data from Firestore
//       const userDoc = await getDoc(doc(db, 'users', user.uid));
      
//       if (userDoc.exists()) {
//         const userData = userDoc.data();
        
//         // Store auth token
//         const token = await user.getIdToken();
//         localStorage.setItem('authToken', token);
        
//         // Store user data in localStorage for app usage
//         localStorage.setItem('userData', JSON.stringify({
//           uid: user.uid, // Add UID to stored data
//           email: user.email,
//           name: userData.name,
//           phone: userData.phone,
//           deliveryAddress: userData.deliveryAddress
//         }));
        
//         // Store location for delivery
//         if (userData.deliveryAddress) {
//           localStorage.setItem('userLocation', JSON.stringify({
//             address: userData.deliveryAddress,
//             formattedAddress: userData.deliveryAddress
//           }));
//         }
        
//         // Update last login time in Firestore
//         await setDoc(doc(db, 'users', user.uid), {
//           lastLogin: serverTimestamp()
//         }, { merge: true });
        
//         // Dispatch a custom event to notify other components
//         window.dispatchEvent(new Event('userLoggedIn'));
        
//         // Redirect user
//         navigate(redirectTo);
//       } else {
//         // If user auth exists but no Firestore document, create one
//         await setDoc(doc(db, 'users', user.uid), {
//           uid: user.uid, // Add UID to Firestore doc
//           email: user.email,
//           name: email.split('@')[0], // Fallback name
//           createdAt: serverTimestamp(),
//           lastLogin: serverTimestamp()
//         });
        
//         // Store minimal user data
//         localStorage.setItem('userData', JSON.stringify({
//           uid: user.uid, // Add UID to stored data
//           email: user.email,
//           name: email.split('@')[0]
//         }));
        
//         // Dispatch a custom event to notify other components
//         window.dispatchEvent(new Event('userLoggedIn'));
        
//         // Redirect user
//         navigate(redirectTo);
//       }
//     } catch (error) {
//       console.error("Login error:", error);
      
//       if (error.code === 'auth/user-not-found') {
//         setError('User not found. Please register.');
//       } else if (error.code === 'auth/wrong-password') {
//         setError('Incorrect password.');
//       } else if (error.code === 'auth/invalid-credential') {
//         setError('Invalid email or password.');
//       } else if (error.code === 'auth/too-many-requests') {
//         setError('Too many unsuccessful login attempts. Please try again later.');
//       } else {
//         setError('Login failed: ' + error.message);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRegister = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     setLoading(true);

//     // Basic validation for phone number (10 digits)
//     const phoneRegex = /^[0-9]{10}$/;
//     if (!phoneRegex.test(phone)) {
//       setError('Please enter a valid 10-digit phone number.');
//       setLoading(false);
//       return;
//     }

//     // Basic validation for delivery address (non-empty)
//     if (!deliveryAddress.trim()) {
//       setError('Please enter a valid delivery address.');
//       setLoading(false);
//       return;
//     }

//     try {
//       // Create user with Firebase Authentication
//       const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//       const user = userCredential.user;

//       // Send email verification
//       await sendEmailVerification(user);
      
//       // Store user data in Firestore
//       await setDoc(doc(db, 'users', user.uid), {
//         uid: user.uid, // Add UID to Firestore doc
//         email: email,
//         name: name,
//         phone: phone,
//         deliveryAddress: deliveryAddress,
//         createdAt: serverTimestamp(),
//         lastLogin: serverTimestamp(),
//         emailVerified: false
//       });

//       // Store auth token
//       const token = await user.getIdToken();
//       localStorage.setItem('authToken', token);
      
//       // Store user data in localStorage for app usage
//       localStorage.setItem('userData', JSON.stringify({
//         uid: user.uid, // Add UID to stored data
//         email: email,
//         name: name,
//         phone: phone,
//         deliveryAddress: deliveryAddress
//       }));
      
//       // Store location for delivery
//       localStorage.setItem('userLocation', JSON.stringify({
//         address: deliveryAddress,
//         formattedAddress: deliveryAddress
//       }));
      
//       // Dispatch a custom event to notify other components
//       window.dispatchEvent(new Event('userLoggedIn'));
      
//       setSuccess('Registration successful! Verification email sent. Please verify your email.');
      
//       // Redirect user after short delay
//       setTimeout(() => {
//         navigate(redirectTo);
//       }, 2000);
//     } catch (error) {
//       console.error("Registration error:", error);
      
//       if (error.code === 'auth/email-already-in-use') {
//         setError('Email already in use. Please login or use a different email.');
//       } else if (error.code === 'auth/weak-password') {
//         setError('Password is too weak. Please use a stronger password.');
//       } else {
//         setError('Registration failed: ' + error.message);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleForgotPassword = () => {
//     // Implement password reset functionality here
//     // This is just a placeholder for now
//     navigate('/forgot-password');
//   };

//   // Show loading indicator while checking auth
//   if (isAuthChecking) {
//     return (
//       <div className="login-container">
//         <div className="login-box">
//           <div className="auth-loading">
//             <div className="spinner"></div>
//             <p>Checking authentication...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="login-container">
//       <div className="login-box">
//         <h2>{isRegistering ? 'Register' : 'Login'}</h2>
//         {error && <div className="login-error">{error}</div>}
//         {success && <div className="login-success">{success}</div>}
//         <form onSubmit={isRegistering ? handleRegister : handleLogin}>
//           {isRegistering && (
//             <>
//               <div className="form-group">
//                 <label htmlFor="name">Name</label>
//                 <input
//                   type="text"
//                   id="name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                   placeholder="Enter your name"
//                   disabled={loading}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="phone">Phone Number</label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   value={phone}
//                   onChange={(e) => setPhone(e.target.value)}
//                   required
//                   placeholder="Enter your 10-digit phone number"
//                   pattern="[0-9]{10}"
//                   disabled={loading}
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="deliveryAddress">Delivery Address</label>
//                 <textarea
//                   id="deliveryAddress"
//                   value={deliveryAddress}
//                   onChange={(e) => setDeliveryAddress(e.target.value)}
//                   required
//                   placeholder="Enter your delivery address"
//                   rows="3"
//                   disabled={loading}
//                 />
//               </div>
//             </>
//           )}
//           <div className="form-group">
//             <label htmlFor="email">Email</label>
//             <input
//               type="email"
//               id="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               placeholder="Enter your email"
//               disabled={loading}
//             />
//           </div>
//           <div className="form-group">
//             <label htmlFor="password">Password</label>
//             <input
//               type="password"
//               id="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//               placeholder="Enter your password"
//               disabled={loading}
//             />
//           </div>
//           <button 
//             type="submit" 
//             className="login-btn"
//             disabled={loading}
//           >
//             {loading ? 'Processing...' : (isRegistering ? 'Register' : 'Login')}
//           </button>
//         </form>
        
//         {!isRegistering && (
//           <p className="forgot-password">
//             <span onClick={handleForgotPassword}>Forgot password?</span>
//           </p>
//         )}
        
//         <p className="toggle-text">
//           {isRegistering ? 'Already have an account?' : "Don't have an account?"}{' '}
//           <span
//             className="toggle-link"
//             onClick={() => {
//               setIsRegistering(!isRegistering);
//               setError('');
//               setSuccess('');
//             }}
//           >
//             {isRegistering ? 'Login' : 'Register'}
//           </span>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;







import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  sendPasswordResetEmail,
  onAuthStateChanged,
  updateProfile,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { 
  doc, 
  setDoc, 
  getDoc, 
  serverTimestamp 
} from 'firebase/firestore';
import { FaTimes, FaSpinner, FaExclamationTriangle, FaUser, FaEnvelope, FaLock, FaSignOutAlt, FaEye, FaEyeSlash, FaGoogle } from 'react-icons/fa';
import { auth, db } from '../../firebase/firebaseConfig';
import { FirestoreService } from '../../firebase/firestoreService';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [isAuthChecking, setIsAuthChecking] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  
  // Forgot password states
  const [isForgotPasswordMode, setIsForgotPasswordMode] = useState(false);
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [resetEmailMessage, setResetEmailMessage] = useState('');
  const [resetEmailError, setResetEmailError] = useState('');
  
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirect URL from the location state, default to root path '/'
  const redirectTo = location.state?.from || '/'; 

  // Check if user is already logged in
  useEffect(() => {
    const checkAuth = async () => {
      setIsAuthChecking(true);
      
      // Wait for auth to initialize
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          setIsLoggedIn(true);
          setCurrentUser(user);
          
          // User is authenticated, fetch user data from Firestore
          try {
            const userDoc = await getDoc(doc(db, 'users', user.uid));
            if (userDoc.exists()) {
              const userData = userDoc.data();
              
              // Get fresh token
              const token = await user.getIdToken(true); // Force refresh token
              localStorage.setItem('authToken', token);
              
              // Store user data in localStorage
              localStorage.setItem('userData', JSON.stringify({
                uid: user.uid,
                email: user.email,
                name: userData.name || user.displayName || 'User',
                phone: userData.phone || '',
                deliveryAddress: userData.deliveryAddress || '',
                points: userData.points || 0
              }));
              
              // Store location for delivery if available
              if (userData.deliveryAddress) {
                localStorage.setItem('userLocation', JSON.stringify({
                  address: userData.deliveryAddress,
                  formattedAddress: userData.deliveryAddress
                }));
              }
              
              // Add session flag to prevent reloading data multiple times
              sessionStorage.setItem('freshLogin', 'true');
              
              // Navigate to home page but don't use window.location.href to avoid reload
              // This will prevent multiple firestore queries on page load
              console.log("User already logged in, redirecting to:", redirectTo);
              navigate(redirectTo, { replace: true });
            } else {
              // User exists in Auth but not in Firestore
              // Clear any stale data
              localStorage.removeItem('userData');
              localStorage.removeItem('authToken');
              localStorage.removeItem('userLocation');
              setIsAuthChecking(false);
            }
          } catch (err) {
            console.error("Error fetching user data:", err);
            // Clear any stale data on error
            localStorage.removeItem('userData');
            localStorage.removeItem('authToken');
            localStorage.removeItem('userLocation');
            setIsAuthChecking(false);
          }
        } else {
          setIsLoggedIn(false);
          setCurrentUser(null);
          // User is not authenticated, clear any stale data
          localStorage.removeItem('userData');
          localStorage.removeItem('authToken');
          localStorage.removeItem('userLocation');
          setIsAuthChecking(false);
        }
      });
      
      return () => unsubscribe();
    };
    
    checkAuth();
  }, [redirectTo, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      // Clear any existing data first
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userLocation');
      
      // Sign in with Firebase Authentication
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Get user data from Firestore
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      
      if (userDoc.exists()) {
        const userData = userDoc.data();
        
        // Store auth token - force refresh to get a new token
        const token = await user.getIdToken(true);
        localStorage.setItem('authToken', token);
        
        // Store user data in localStorage for app usage
        localStorage.setItem('userData', JSON.stringify({
          uid: user.uid,
          email: user.email,
          name: userData.name || user.displayName || 'User',
          phone: userData.phone || '',
          deliveryAddress: userData.deliveryAddress || '',
          points: userData.points || 0
        }));
        
        // Store location for delivery
        if (userData.deliveryAddress) {
          localStorage.setItem('userLocation', JSON.stringify({
            address: userData.deliveryAddress,
            formattedAddress: userData.deliveryAddress
          }));
        }
        
        // Update last login time in Firestore - but don't wait for it
        try {
          setDoc(doc(db, 'users', user.uid), {
            lastLogin: serverTimestamp()
          }, { merge: true }).catch(err => console.warn('Failed to update last login time:', err));
        } catch (updateError) {
          console.warn('Failed to update last login time:', updateError);
        }
        
        // Sync user data from localStorage to Firestore
        try {
          FirestoreService.syncUserData(user.uid).catch(err => 
            console.warn('Non-critical: Failed to sync user data:', err)
          );
        } catch (syncError) {
          console.warn('Non-critical: Failed to sync user data:', syncError);
        }
        
        // Dispatch a custom event to notify other components
        window.dispatchEvent(new Event('userLoggedIn'));
        
        // Add session flag to prevent reloading data multiple times
        sessionStorage.setItem('freshLogin', 'true');
        
        // Navigate to home page
        console.log("Login successful, redirecting to:", redirectTo);
        navigate(redirectTo, { replace: true });
      } else {
        // If user auth exists but no Firestore document, create one
        const userData = {
          uid: user.uid,
          email: user.email,
          name: user.displayName || email.split('@')[0],
          createdAt: serverTimestamp(),
          lastLogin: serverTimestamp(),
          points: 0
        };
        
        try {
          // Create the user document
          await setDoc(doc(db, 'users', user.uid), userData);
        } catch (createError) {
          console.warn('Failed to create user document:', createError);
          // Continue anyway since we have authentication
        }
        
        // Store minimal user data
        localStorage.setItem('userData', JSON.stringify({
          uid: user.uid,
          email: user.email,
          name: user.displayName || email.split('@')[0],
          points: 0
        }));
        
        // Get token
        const token = await user.getIdToken(true);
        localStorage.setItem('authToken', token);
        
        // Dispatch a custom event to notify other components
        window.dispatchEvent(new Event('userLoggedIn'));
        
        // Add session flag to prevent reloading data multiple times
        sessionStorage.setItem('freshLogin', 'true');
        
        // Navigate to home page
        console.log("Created new user profile, redirecting to:", redirectTo);
        navigate(redirectTo, { replace: true });
      }
    } catch (error) {
      console.error("Login error:", error);
      
      if (error.code === 'auth/user-not-found') {
        setError('User not found. Please register.');
      } else if (error.code === 'auth/wrong-password') {
        setError('Incorrect password.');
      } else if (error.code === 'auth/invalid-credential') {
        setError('Invalid email or password.');
      } else if (error.code === 'auth/too-many-requests') {
        setError('Too many unsuccessful login attempts. Please try again later.');
      } else {
        setError('Login failed: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };
  
  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    // Basic validation for phone number (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      setError('Please enter a valid 10-digit phone number.');
      setLoading(false);
      return;
    }

    // Basic validation for delivery address (non-empty)
    if (!deliveryAddress.trim()) {
      setError('Please enter a valid delivery address.');
      setLoading(false);
      return;
    }

    try {
      // Clear any existing data first
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userLocation');
      
      // Create user with Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Update profile with display name
      try {
        await updateProfile(user, {
          displayName: name
        });
      } catch (profileError) {
        console.warn('Failed to update profile:', profileError);
        // Continue anyway
      }

      // Send email verification (don't wait for it)
      try {
        sendEmailVerification(user).catch(err => 
          console.warn('Failed to send verification email:', err)
        );
      } catch (verifyError) {
        console.warn('Failed to send verification email:', verifyError);
      }
      
      // Prepare user data
      const userData = {
        uid: user.uid,
        email: email,
        name: name,
        phone: phone,
        deliveryAddress: deliveryAddress,
        createdAt: serverTimestamp(),
        lastLogin: serverTimestamp(),
        emailVerified: false,
        points: 0
      };
      
      // Store user data in Firestore
      try {
        await setDoc(doc(db, 'users', user.uid), userData);
      } catch (firestoreError) {
        console.warn('Failed to create user document:', firestoreError);
        // Continue anyway since we have authentication
      }

      // Store auth token
      const token = await user.getIdToken(true);
      localStorage.setItem('authToken', token);
      
      // Store user data in localStorage for app usage
      localStorage.setItem('userData', JSON.stringify({
        uid: user.uid,
        email: email,
        name: name,
        phone: phone,
        deliveryAddress: deliveryAddress,
        points: 0
      }));
      
      // Store location for delivery
      localStorage.setItem('userLocation', JSON.stringify({
        address: deliveryAddress,
        formattedAddress: deliveryAddress
      }));
      
      // Dispatch a custom event to notify other components
      window.dispatchEvent(new Event('userLoggedIn'));
      
      setSuccess('Registration successful! Verification email sent. Please verify your email.');
      
      // Add session flag to prevent reloading data multiple times
      sessionStorage.setItem('freshLogin', 'true');
      
      // Navigate after short delay to show success message
      setTimeout(() => {
        console.log("Registration successful, redirecting to:", redirectTo);
        navigate(redirectTo, { replace: true });
      }, 2000);
    } catch (error) {
      console.error("Registration error:", error);
      
      if (error.code === 'auth/email-already-in-use') {
        setError('Email already in use. Please login or use a different email.');
      } else if (error.code === 'auth/weak-password') {
        setError('Password is too weak. Please use a stronger password.');
      } else {
        setError('Registration failed: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // Function to handle Google Sign-In
  const handleGoogleSignIn = async () => {
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });

      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check if user exists in Firestore
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      
      if (!userDoc.exists()) {
        // New user - create profile in Firestore
        const userData = {
          uid: user.uid,
          email: user.email,
          name: user.displayName || 'User',
          phone: '',
          deliveryAddress: '',
          createdAt: serverTimestamp(),
          lastLogin: serverTimestamp(),
          emailVerified: user.emailVerified,
          points: 0,
          photoURL: user.photoURL || ''
        };
        
        await setDoc(doc(db, 'users', user.uid), userData);
        
        // Store user data in localStorage
        localStorage.setItem('userData', JSON.stringify({
          uid: user.uid,
          email: user.email,
          name: user.displayName || 'User',
          phone: '',
          deliveryAddress: '',
          points: 0
        }));
      } else {
        // Existing user - update last login
        const userData = userDoc.data();
        
        await setDoc(doc(db, 'users', user.uid), {
          lastLogin: serverTimestamp(),
          emailVerified: user.emailVerified
        }, { merge: true });
        
        // Store user data in localStorage
        localStorage.setItem('userData', JSON.stringify({
          uid: user.uid,
          email: user.email,
          name: userData.name || user.displayName || 'User',
          phone: userData.phone || '',
          deliveryAddress: userData.deliveryAddress || '',
          points: userData.points || 0
        }));
        
        // Store location for delivery if available
        if (userData.deliveryAddress) {
          localStorage.setItem('userLocation', JSON.stringify({
            address: userData.deliveryAddress,
            formattedAddress: userData.deliveryAddress
          }));
        }
      }

      // Store auth token
      const token = await user.getIdToken(true);
      localStorage.setItem('authToken', token);
      
      // Dispatch event to notify other components
      window.dispatchEvent(new Event('userLoggedIn'));
      
      // Add session flag
      sessionStorage.setItem('freshLogin', 'true');
      
      setSuccess('Successfully signed in with Google!');
      
      // Navigate to redirect destination
      setTimeout(() => {
        navigate(redirectTo, { replace: true });
      }, 1000);
      
    } catch (error) {
      console.error("Google sign-in error:", error);
      
      if (error.code === 'auth/popup-closed-by-user') {
        setError('Sign-in cancelled. Please try again.');
      } else if (error.code === 'auth/popup-blocked') {
        setError('Pop-up blocked. Please enable pop-ups for this site.');
      } else if (error.code === 'auth/cancelled-popup-request') {
        // User opened another popup, ignore this error
        setError('');
      } else {
        setError('Google sign-in failed: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // Function to handle password reset
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setResetEmailError('');
    setResetEmailMessage('');
    setIsResettingPassword(true);

    if (!email.trim()) {
      setResetEmailError('Please enter your email address');
      setIsResettingPassword(false);
      return;
    }

    try {
      // Use Firebase's password reset function with a proper continue URL
      await sendPasswordResetEmail(auth, email, {
        url: window.location.origin + '/login',
        handleCodeInApp: false
      });
      
      setResetEmailMessage(`Password reset email sent to ${email}. Please check your inbox and spam folder.`);
      
      // Return to login form after a short delay
      setTimeout(() => {
        setIsForgotPasswordMode(false);
      }, 5000);
    } catch (error) {
      console.error("Password reset error:", error);
      
      if (error.code === 'auth/user-not-found') {
        // For security reasons, still show a success message to prevent email enumeration
        setResetEmailMessage('If an account exists with this email, a password reset link has been sent.');
      } else if (error.code === 'auth/invalid-email') {
        setResetEmailError('Please enter a valid email address.');
      } else if (error.code === 'auth/too-many-requests') {
        setResetEmailError('Too many password reset attempts. Please try again later.');
      } else if (error.code === 'auth/invalid-continue-uri') {
        setResetEmailError('Error with password reset configuration. Please contact support.');
        console.error('Invalid continue URI error. Make sure your domain is authorized in Firebase console.');
      } else {
        setResetEmailError('Failed to send password reset email: ' + error.message);
      }
    } finally {
      setIsResettingPassword(false);
    }
  };

  // Handle logout
  const handleLogout = async () => {
    setLoading(true);
    try {
      await signOut(auth);
      // Clear all user data
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userLocation');
      sessionStorage.removeItem('freshLogin');
      
      setIsLoggedIn(false);
      setCurrentUser(null);
      setSuccess('Successfully logged out!');
      
      // Dispatch a custom event
      window.dispatchEvent(new Event('userLoggedOut'));
      
      // Navigate to login page
      navigate('/login', { replace: true });
    } catch (error) {
      setError('Failed to log out. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Reset form when switching between modes
  const resetForm = () => {
    setError('');
    setSuccess('');
    setResetEmailError('');
    setResetEmailMessage('');
  };

  // Show loading indicator while checking auth
  if (isAuthChecking) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="auth-loading">
            <div className="spinner"></div>
            <p>Checking authentication...</p>
          </div>
        </div>
      </div>
    );
  }

  // If user is already logged in
  if (isLoggedIn && currentUser) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2>Welcome, {currentUser?.displayName || 'User'}</h2>
          <p>You are currently logged in.</p>
          
          <div className="user-details">
            <p><strong>Name:</strong> {currentUser?.displayName || 'Not set'}</p>
            <p><strong>Email:</strong> {currentUser?.email || 'Not set'}</p>
          </div>
          
          {resetEmailMessage && (
            <div className="login-success">
              <span>{resetEmailMessage}</span>
            </div>
          )}
          
          {resetEmailError && (
            <div className="login-error">
              <FaExclamationTriangle />
              <span>{resetEmailError}</span>
            </div>
          )}
          
          <div className="logged-in-actions">
            <button
              className="login-btn"
              onClick={() => navigate('/profile')}
              disabled={loading || isResettingPassword}
            >
              Go to Profile
            </button>
            
            <button
              className="login-btn logout-btn"
              onClick={handleLogout}
              disabled={loading || isResettingPassword}
            >
              {loading ? (
                <>
                  <FaSpinner className="spinner" />
                  <span>Logging out...</span>
                </>
              ) : (
                <>
                  <FaSignOutAlt />
                  <span>Log Out</span>
                </>
              )}
            </button>
            
            <button
              className="login-btn reset-password-btn"
              onClick={() => {
                setEmail(currentUser.email);
                handleForgotPassword({ preventDefault: () => {} });
              }}
              disabled={isResettingPassword}
            >
              {isResettingPassword ? (
                <>
                  <FaSpinner className="spinner" />
                  <span>Sending Reset Email...</span>
                </>
              ) : (
                <>
                  <FaLock />
                  <span>Reset Password</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Render the forgot password form
  if (isForgotPasswordMode) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2>Reset Your Password</h2>
          <p>Enter your email address and we'll send you a password reset link.</p>
          
          {resetEmailError && <div className="login-error">
            <FaExclamationTriangle />
            <span>{resetEmailError}</span>
          </div>}
          
          {resetEmailMessage && <div className="login-success">
            <span>{resetEmailMessage}</span>
          </div>}
          
          <form onSubmit={handleForgotPassword}>
            <div className="form-group">
              <label htmlFor="reset-email">Email Address</label>
              <div className="input-with-icon">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  id="reset-email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (resetEmailError) setResetEmailError('');
                  }}
                  disabled={isResettingPassword}
                />
              </div>
            </div>
            
            <button 
              type="submit" 
              className="login-btn"
              disabled={isResettingPassword}
            >
              {isResettingPassword ? (
                <>
                  <FaSpinner className="spinner" />
                  <span>Sending Reset Email...</span>
                </>
              ) : (
                <span>Send Reset Link</span>
              )}
            </button>
          </form>
          
          <p className="toggle-text">
            Remembered your password?{' '}
            <span
              className="toggle-link"
              onClick={() => {
                setIsForgotPasswordMode(false);
                resetForm();
              }}
            >
              Back to Login
            </span>
          </p>
        </div>
      </div>
    );
  }

  // Render the login/register form
  return (
    <div className="login-container">
      <div className="login-box">
        <div className="auth-banner">
          <div className="auth-banner-content">
            <h1>ProCart</h1>
            <p>Your one-stop solution for Embeded Components, delivered in one day.</p>
            
          </div>
        </div>
      
        <h2>{isRegistering ? 'Create an Account' : 'Welcome Back'}</h2>
        <p>{isRegistering 
          ? 'Sign up to start your shopping journey' 
          : 'Sign in to continue your shopping experience'}</p>
          
        {error && <div className="login-error">
          <FaExclamationTriangle />
          <span>{error}</span>
        </div>}
        
        {success && <div className="login-success">{success}</div>}
        
        <form onSubmit={isRegistering ? handleRegister : handleLogin}>
          {isRegistering && (
            <>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <div className="input-with-icon">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (error) setError('');
                    }}
                    required
                    placeholder="Enter your name"
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                  placeholder="Enter your 10-digit phone number"
                  pattern="[0-9]{10}"
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <label htmlFor="deliveryAddress">Delivery Address</label>
                <textarea
                  id="deliveryAddress"
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                  required
                  placeholder="Enter your delivery address"
                  rows="3"
                  disabled={loading}
                />
              </div>
            </>
          )}
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <div className="input-with-icon">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError('');
                }}
                required
                placeholder="Enter your email"
                disabled={loading}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-with-icon password-input-container">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError('');
                }}
                required
                placeholder="Enter your password"
                disabled={loading}
              />
              <button 
                type="button"
                className="toggle-password-visibility"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {!isRegistering && (
              <div className="forgot-password-link">
                <button 
                  type="button" 
                  onClick={() => {
                    setIsForgotPasswordMode(true);
                    resetForm();
                  }}
                  className="text-link"
                  disabled={loading}
                >
                  Forgot your password?
                </button>
              </div>
            )}
          </div>
          <button 
            type="submit" 
            className="login-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <FaSpinner className="spinner" />
                <span>{isRegistering ? 'Creating Account...' : 'Signing in...'}</span>
              </>
            ) : (
              <span>{isRegistering ? 'Create Account' : 'Sign In'}</span>
            )}
          </button>
        </form>
        
        {!isRegistering && (
          <>
            <div className="divider">
              <span>OR</span>
            </div>
            
            <button 
              type="button"
              className="google-signin-btn"
              onClick={handleGoogleSignIn}
              disabled={loading}
            >
              {loading ? (
                <>
                  <FaSpinner className="spinner" />
                  <span>Signing in...</span>
                </>
              ) : (
                <>
                  <FaGoogle className="google-icon" />
                  <span>Continue with Google</span>
                </>
              )}
            </button>
          </>
        )}
        
        <div className="login-footer">
          {isRegistering ? (
            <>
              <p>Already have an account?</p>
              <button
                className="switch-form-btn"
                onClick={() => {
                  setIsRegistering(false);
                  resetForm();
                }}
                disabled={loading}
              >
                Login
              </button>
            </>
          ) : (
            <>
              <p>New to ProCart?</p>
              <button
                className="switch-form-btn"
                onClick={() => {
                  setIsRegistering(true);
                  resetForm();
                }}
                disabled={loading}
              >
                Create an Account
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;